import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

const ChromeOutlineIcon = (props: SVGProps): JSX.Element => {
  const { title = 'Chrome Outline', className, ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn('text-color-ref-primary-primary-50', className)}
      fill="none"
      {...restProps}
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.9267 8.01779C3.3334 9.21832 3 10.5702 3 12C3 16.4085 6.16967 20.0767 10.3544 20.8499L12.5953 16.9649C12.4001 16.9881 12.2014 17 12 17C10.0741 17 8.40255 15.9112 7.56732 14.3155L3.9267 8.01779ZM3.09491 5.54116C1.77718 7.35484 1 9.58666 1 12C1 17.6355 5.23791 22.2812 10.7007 22.9241C10.7461 22.9324 10.7918 22.9374 10.8375 22.9393C11.2195 22.9794 11.6074 23 12 23C18.0751 23 23 18.0751 23 12C23 10.4588 22.683 8.99164 22.1108 7.66013C22.096 7.61934 22.0787 7.57979 22.059 7.54166C20.3484 3.68785 16.4881 1 12 1C8.40396 1 5.21094 2.72557 3.20381 5.39387C3.16274 5.43986 3.12637 5.48921 3.09491 5.54116ZM5.15842 6.15229L7.40178 10.033C8.16572 8.24947 9.93695 7 12 7H19.4845C17.8699 4.58803 15.1204 3 12 3C9.26175 3 6.80911 4.22287 5.15842 6.15229ZM20.4879 9H16.0004C16.6281 9.83566 17 10.8744 17 12C17 12.9834 16.7161 13.9006 16.2257 14.6739L12.5875 20.9811C17.2842 20.6785 21 16.7732 21 12C21 10.9481 20.8195 9.93834 20.4879 9ZM14.6365 13.4326C14.8683 13.0069 15 12.5188 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 12.4905 9.11773 12.9536 9.32649 13.3624L9.40575 13.4995C9.41884 13.5222 9.43093 13.5451 9.44206 13.5683C9.96979 14.4272 10.918 15 12 15C13.0559 15 13.9845 14.4544 14.5191 13.6298L14.5938 13.5003C14.6072 13.477 14.6215 13.4544 14.6365 13.4326Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { ChromeOutlineIcon };
